import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

import InputError from '../../atom/InputError';
import style from './Input.module.scss';

const cx = classNames.bind(style);

const Input = forwardRef(
  (
    {
      value,
      id,
      onChange,
      dataTestId,
      type,
      labelCopy,
      placeholder,
      name,
      error,
      errorType,
      autoComplete,
      variant,
      ...rest
    },
    ref,
  ) => (
    <div
      className={`input-wrapper ${cx('input-container', variant)}`}
      data-qa={`${dataTestId}-input`}
    >
      <label
        className={cx('label', id)}
        htmlFor={id}
        data-qa={`${dataTestId}-label`}
      >
        {labelCopy ? (
          <p className={cx('label__copy')} data-qa="label-text">
            {labelCopy}
          </p>
        ) : null}
        <input
          ref={ref}
          className={cx('input', { 'input-error': error })}
          type={type}
          id={id}
          value={value}
          onChange={onChange}
          data-qa={dataTestId}
          placeholder={placeholder}
          name={name}
          autoComplete={autoComplete}
          {...rest}
        />
      </label>
      {error && <InputError message={error} errorType={errorType} />}
    </div>
  ),
);

Input.propTypes = {
  id: PropTypes.string.isRequired,
  dataTestId: PropTypes.string.isRequired,
  value: PropTypes.string,
  type: PropTypes.string,
  labelCopy: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  name: PropTypes.string,
  error: PropTypes.string,
  errorType: PropTypes.string,
  autoComplete: PropTypes.string,
  variant: PropTypes.string,
};

Input.defaultProps = {
  onChange: () => null,
  placeholder: '',
  type: 'text',
  name: '',
  error: undefined,
  errorType: undefined,
  autoComplete: '',
  labelCopy: '',
  value: undefined,
  variant: '',
};

export default Input;
